import React from 'react';
import { Icon } from '@alifd/next';
import styles from '../index.module.scss';

import TagRadio from './Nodes/TagRadio';
import TagCheckbox from './Nodes/TagCheckbox';
import TagProvince from './Nodes/TagProvince';
import TagSlider from './Nodes/TagSlider';
import TagSection from './Nodes/TagSection';
import TagSku from './Nodes/TagSku';
import TagCategories from './Nodes/TagCategories';
import TagCrowd from './Nodes/TagCrowd';
import TagTime from './Nodes/TagTime';
import TagRadioDouble from './Nodes/TagRadioDouble';

/**
 *  根据后端返回的type确定不同类型的标签展示，1.单选 2.多选枚举 3.级联多选 4.整数值 5.数值区间 6.时间区间 7.商品种类 8.人群包类型 9.自定义(原来的)
 * 根据后端返回的type确定不同类型的标签展示，1.单选 2.多选 5.区间值 6.时间区间  9.自定义(sku) 10.单选里再多一层级(例:近期在直播间下单sku:直播间类型)
 * @param activeTagList-点击左侧标签统计出的所有选中标签
 * @param changeActiveTagValue-对标签选框进行了编辑，传到父组件去修改值
 * @param changeActiveList-点击每个取消图标，删除一个选中标签
 */

// 这个是需要的所有组件，通过标签的valueType判断用哪个组件
const arr = [TagRadio, TagCheckbox, TagProvince, TagSlider, TagSection, TagTime, TagCategories, TagCrowd, TagSku, TagRadioDouble];

const TagMapping = ({
  activeTagList = [],
  changeActiveTagValue = (contIndex, index, subIndex, infoIndex, newData) => {},
  changeActiveList = (contItem, contIndex, item, subItem, index, subIndex) => {},
  pageType = ''// '1'创建 '2'复制
}) => {
  return (
    <>
      {
        activeTagList.map((contItem, contIndex) => {
          return (
            <div key={`contItem_${contIndex}`}>
              <div className={`${styles['tag-title']}`}>
                {/* 大分类的title,只展示一次 */}
                {contItem?.crowdLabels?.length >= 1 && <span>{contItem.labelDescription}</span>}
              </div>
              <section className={`${styles['tag-content']}`}>
                {
                    contItem.crowdLabels.map((item, index) => {
                      return (
                        <div key={`item_${index}`}>
                          {/* 二级分类title,只展示一次 */}
                          {item.crowdLabels.length >= 1 && <div style={{marginBottom:'2px'}}>{item.labelDescription}</div>}
                          {
                              item.crowdLabels.map((subItem, subIndex) => {
                                return (
                                  <div key={`subItem_${subIndex}`}>
                                    <div key={subItem.id} className={`${styles.mb15}`}>
                                      <section
                                        className={`${styles['tag-name']}`}
                                        style={{ position: 'relative' }}
                                      >
                                        {subItem.labelName}
                                        <span className={styles['title-decs']}>
                                          {subItem.labelDescription}
                                        </span>
                                        <Icon
                                          onClick={(event) => {
                                            changeActiveList(contItem, contIndex, item, index, subItem, subIndex);
                                          }}
                                          type="close"
                                          size="xs"
                                          style={{
                                            cursor: 'pointer',
                                            position: 'absolute',
                                            top: '10px',
                                            right: '15px',
                                          }}
                                        />
                                      </section>
                                      {
                                        subItem.crowdLabels.map((infoItem,infoIndex)=>{
                                          let Content = null;
                                          Content = arr[+infoItem.valueType - 1];
                                          return (
                                            <div className={`${styles['editTag-content']}`} key={`infoItem_${infoIndex}`}>
                                              <Content
                                                tagItem={infoItem}
                                                changeData={(newData) => changeActiveTagValue(contIndex, index, subIndex, infoIndex, newData)}
                                                pageType={pageType}
                                              />
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                );
                              })
                            }
                        </div>
                      );
                    })}
              </section>
            </div>
          );
        })
      }
    </>
  );
};
export default TagMapping;
